import { LINKS } from '@/Module/Core/Constant';
import type { ILesson } from '@/Module/Lesson/Model/DataModel';

interface IProps extends Pick<ILesson, 'id' | 'seoUrlSlug'> {
  gradeSeoUrlSlug: string;
}

export const prepareLessonUrl = ({ gradeSeoUrlSlug, seoUrlSlug }: IProps) => {
  return LINKS.LESSON.replace('[gradeSlug]', gradeSeoUrlSlug).replace('[lessonSlug]', seoUrlSlug);
};
